export default __webpack_public_path__ + "static/media/ping-pong.e8ace107.svg";